// PhonicsLt11.js
// 包装组件：Letter Teams L11
// 路由：/phonics/lt11
import React from 'react';
import PhonicsLt from './phonics/PhonicsLt';
import { letterDataLt11 } from './phonics/phonics_data_lt11';

function PhonicsLt11() {
  return <PhonicsLt letterData={letterDataLt11} />;
}

export default PhonicsLt11;
